<template>
  <z-dialogo
    ref="dialogo"
    titulo="Produtos"
    scrollable
    dividers
    no-padding
    largura="1000px"
    altura="383px"
  >
    <template v-slot:prepend>
      <v-toolbar flat color="white">
        <v-text-field
          ref="busca"
          v-model="busca.descricao"
          outlined
          filled
          single-line
          dense
          label="Pesquisar"
          clearable
          hide-details
          prepend-inner-icon="mdi-magnify"
          @keydown.enter="buscar"
          @focus="onBuscaFocus"
          @click:clear="limparBusca"
          @blur="is_busca_focused = false"
        ></v-text-field>
      </v-toolbar>
    </template>

    <template v-slot:conteudo>
      <z-splitter left-width="250px" :hide-left="grupos.length <= 2 || true">

        <template v-slot:panel1>
          <v-card class="d-flex flex-column fill-height">
            <v-card-text ref="cardScroll" class="pa-0 fill-height nice-scrollbar">
  
              <v-list dense nav>
                <v-subheader>Grupos</v-subheader>
                <v-list-item-group mandatory v-model="selectedItem" color="primary">
                  <template v-for="(grupo, i) in grupos">
                    <v-list-item :key="i" @click="selecionarGrupo(grupo)">
                      <v-list-item-content>
                        <v-list-item-title class="text-uppercase" v-text="grupo.text"></v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-list-item-group>
              </v-list>

            </v-card-text>
          </v-card>

        </template>
          
        <template v-slot:panel2>

          <v-card class="d-flex flex-column fill-height">
            <v-card-text class="pa-0 fill-height nice-scrollbar">
              <div ref="topo"></div>
              <v-data-table
                disable-pagination
                disable-sort
                hide-default-footer
                :headers="headers"
                :items="produtos"
                :loading="carregando"
              >
              <template v-slot:body="{ items: produtos }">
                <tbody>
                  <tr 
                    v-for="(produto, index) in produtos" 
                    ref="urls" 
                    :key="index" 
                    class="apontador noselect" 
                    :class="{'active': isActive(index)}" 
                    @click="selecionar(produto)" 
                  >
                    <td class="text-no-wrap">{{ produto.referencia }}</td>
                    <td>
                      <div>{{ produto.descricao }}</div>
                      <template v-if="produto.variacoes">
                        <v-chip
                          v-for="(variacao, index) in produto.variacoes"
                          class="mr-2"
                          x-small 
                          color="grey lighten-2"
                          :key="index"
                        >{{variacao.descricao}}</v-chip>
                      </template>
                    </td>
                    <td class="text-right">{{ produto.estoque | valorBR(0) }} {{ produto.unidade }}</td>
                    <td class="text-right">{{ produto.valor_venda | valorBR }}</td>
                  </tr>
                </tbody>
              </template>

                <template v-if="false" v-slot:item="{ item: produto, index }">
                  <tr
                    ref="urls" 
                    style="cursor: pointer"
                    class="apontador noselect" 
                    :class="{'active': isActive(index)}"
                    @click="selecionar(produto)" 
                  >
                    <td class="text-no-wrap">{{ produto.referencia }}</td>
                    <td>
                      <div>{{ produto.descricao }}</div>
                      <template v-if="produto.variacoes">
                        <v-chip
                          v-for="(variacao, index) in produto.variacoes"
                          class="mr-2"
                          x-small 
                          color="grey lighten-2"
                          :key="index"
                        >{{variacao.descricao}}</v-chip>
                      </template>
                    </td>
                    <td class="text-right">{{ produto.estoque | valorBR(0) }} {{ produto.unidade }}</td>
                    <td class="text-right">{{ produto.valor_venda | valorBR }}</td>
                  </tr>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
          
        </template>
      </z-splitter>
    </template>

    <template v-slot:actions_left>
      <span class="text-subtitle-2">Produtos encontrados: {{ produtos.length }}</span>
    </template>
    <template v-slot:actions_right>
      <v-btn depressed color="primary" @click="fechar()">ESC - Fechar</v-btn>
    </template>
  </z-dialogo>
</template>

<script>
import produtosApi from "@/app/services/produtos";

import { mapGetters } from "vuex";

import buscas_mixin from "@/app/mixins/buscas";

export default {
  name: "DialogoBuscarProdutoGrupos",
  mixins: [buscas_mixin],

  data() {
    return {
      produtos: [],
      busca: {
        descricao: '',
        grupo: '' 
      },
      headers: [
        { text: "Referência", value: "referencia", width: "100px" },
        { text: "Descrição", value: "descricao" },
        { text: "Estoque", value: "estoque", align: "right" },
        { text: "Valor", value: "valor_venda", align: "right" },
      ],
      carregando: false,
      selectedItem: 0,
      grupoSelecionado: {}
    };
  },


  computed: {
    ...mapGetters("listas", ["grupos"]),
  },

  methods: {
    async carregarGrupos() {
      await this.$store.dispatch("listas/grupos");
      this.grupos.unshift({
        text: 'Todos',
        value: 0
      })
    },

    async abrir(referencia = null) {
      if (referencia) {
        this.busca.descricao = referencia;
        await this.buscar();
      }

      await this.carregarGrupos();
      this.$refs.dialogo.abrir();
      this.setFocus("busca", 300);
      // this.grupoSelecionado = {}
      // this.selectedItem = 0;

      // this.atual = 0;
      setTimeout(() => {
        this.scrollList();
      }, 100);

      window.addEventListener('keydown', this.teclas);
    },

    fechar() {
      window.removeEventListener('keydown', this.teclas);
      setTimeout(() => {
        this.$refs.dialogo.fechar();
      }, 200);
    },

    async buscar(event) {
      try {
        // if (this.busca && this.busca.length > 0) {
          // this.$refs.busca.select();
          if (event) {
            event.target.select();
          }

          this.busca.grupo = this.grupoSelecionado.value;
          this.carregando = true;
          this.produtos = await this.$store.dispatch("produtos/buscarProdutoPorDescricao", {...this.busca});
        // }
      } catch (error) {
        this.$eventbus.erroSistema(error);
      } finally {
        this.carregando = false;
      }
    },

    selecionar(produto) {
      this.$emit("selecionar:produto", produto);
      this.fechar();
    },

    onBuscaFocus(event) {
      console.log("onBuscaFocus");
      event.target.select(); 
      this.is_busca_focused = true;
    },

    limparBusca() {
      this.busca = {
        descricao: '',
        grupo: 0 
      };
      // this.grupoSelecionado = {}
      this.produtos = [];

      setTimeout(() => {
        this.buscar();
      }, 0)
    },

    selecionarGrupo(grupo) {
      this.grupoSelecionado = grupo;
      queueMicrotask(() => {
        this.buscar();
        this.setFocus("busca", 300);
      })
    }
  },
};
</script>

<style scoped></style>
